/** 消化内科 */

/** 对应的标题 */
const categoryMap = {
  PEN: '胰腺内分泌肿瘤（PEN）类型及征象',
  Rutgeerts: 'Rutgeerts分级',
  EndStageLiverDisease: '终末期肝病模型',
  PanNeuTumor: '胰腺神经内分泌肿瘤分期',
  ProteinIntake: '蛋白质摄入量',
  BalthazarCT: 'BalthazarCT指数',
  ABIC: 'ABIC评分',
  APRI: 'APRI评分',
  BISAP: 'BISAP评分',
  AnionGapSerum: '阴离子间隙（血清）',
  BristolStool: 'Bristol粪便分类表',
  MarshallScoringSystem: 'Marshall评分系统',
  GERDGrading: '反流性食管炎（GERD）分级',
  TNMStaging: '甲状腺肿瘤TNM分期',
  StoolOsmoticGap: '粪便渗透压差'
}
/** 对应的描述 */
const categoryDescMap = {
  PEN: '',
  Rutgeerts: '评估克罗恩病（CD）复发症状严重度',
  EndStageLiverDisease: '评估12岁及12岁以上终末期肝病死亡风险',
  PanNeuTumor: '评估胰腺神经内分泌肿瘤患者病情进展',
  ProteinIntake: '不同机体状态每日蛋白需求量',
  BalthazarCT: '根据CT评估急性胰腺炎严重度',
  ABIC: '酒精性肝炎预后评估',
  APRI: '检测慢性丙肝患者肝硬化',
  BISAP: '胰腺炎预后评估工具',
  AnionGapSerum: '诊断代谢性酸中毒',
  BristolStool: '区别人类分辨形态',
  MarshallScoringSystem: '急性胰腺炎器官衰竭评估',
  GERDGrading: 'Los Angeles分级系统',
  TNMStaging: '评估甲状腺肿瘤患者病情进展',
  StoolOsmoticGap: '排除渗透性腹泻'
}
export default {
  categoryMap,
  categoryDescMap
}



// WEBPACK FOOTER //
// ./src/utils/category/GD.js